// import  fetch  from '../config/fetch'
import { baseFMUrl, weChatRedirectUrl, XAUTHTOKEN } from "../config/env";

// import md5 from '../../static/md5.js'
var aVersions = [
  "MSXML2.XMLHttp.5.0",
  "MSXML2.XMLHttp.4.0",
  "MSXML2.XMLHttp.3.0",
  "MSXML2.XMLHttp",
  "Microsoft.XMLHttp"
];
function isEnglishPhone() {
    const lang = (
        navigator.language ||
        navigator.userLanguage ||
        ''
    ).toLowerCase();

    return lang.indexOf('en') === 0;
}

var ajax = (type = "GET", url = "", data = {}, async = true) => {
  return new Promise((resolve, reject) => {
    // 定义一个promise
    type = type.toUpperCase();
    let requestObj;
    if (window.XMLHttpRequest) {
      // requestObj = new window.XMLHttpRequest();
      requestObj = new XMLHttpRequest();
    } else {
      // requestObj = new ActiveXObject('Microsoft.XMLHTTP');
      for (i = 0; i < aVersions.length; i++) {
        try {
          requestObj = new ActiveXObject(aVersions[i]);
          return;
        } catch (Error) { }
      }
    }
    // console.log(type);
    if (type == "GET") {
      let dataStr = ""; //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + "=" + data[key] + "&";
      });
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      url = url + "?" + dataStr;
      // console.log('get:'+url);
      requestObj.open(type, url, async);
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      let token = window.localStorage.getItem(XAUTHTOKEN);

      if (token) {
        requestObj.setRequestHeader("x-auth-token", token); // '1b8a19c2-eafa- -8787-9174b2c1a4d5'
      }
         var lang = localStorage.getItem("lang");
      if (lang == 't') {
        requestObj.setRequestHeader("locale", "taiwan");
      } else {
        requestObj.setRequestHeader("locale", "cn");
      }
      // requestObj.setRequestHeader("x-channel", "FM_WXH5-2");
      requestObj.setRequestHeader("x-channel", sessionStorage.getItem('isBocAPP') == '1' ? "FM_WXH5-20" : "FM_WXH5-2");
      requestObj.send();
    } else if (type == "POST") {
      requestObj.open(type, url, async);
      // console.log('post:'+url);
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      ); //必须,否则无法传参
      let token = window.localStorage.getItem(XAUTHTOKEN);
      // console.log(token);
      if (token) {
        requestObj.setRequestHeader("x-auth-token", token); // '1b8a19c2-eafa- -8787-9174b2c1a4d5'
      }
      // requestObj.setRequestHeader("x-channel", "FM_WXH5-2");
      requestObj.setRequestHeader("x-channel", sessionStorage.getItem('isBocAPP') == '1' ? "FM_WXH5-20" : "FM_WXH5-2");
      var lang = localStorage.getItem("lang");
      if (lang == 't') {
        requestObj.setRequestHeader("locale", "taiwan");
      } else {
        requestObj.setRequestHeader("locale", "cn");
      }
      requestObj.send(data);
      //      requestObj.send(JSON.stringify(data).replace(/,/g, '&').replace(/:/g, '=').replace(/\'/g, '').replace('{','').replace('}',''));//参数形式'a=1&b=2'
    } else {
      reject("error type");
    }

    requestObj.onreadystatechange = () => {
      if (requestObj.readyState == 4) {
        if (requestObj.status == 200) {
          let obj = requestObj.response;

          if (typeof obj !== "object") {
            obj = JSON.parse(obj);
          }
          if (obj.header.status == 1105) {
            console.log(obj.header.msg);
            window.localStorage.removeItem(XAUTHTOKEN);

            //  window.sessionStorage.setItem("E_BEFORE_LOGIN_URL_EXHIBITION_NEW", window.location.href);

            // //开始
            // let ua = window.navigator.userAgent.toLowerCase();
            // if (ua.match(/micromessenger/i) == "micromessenger") {
            //     setTimeout(function(){
            //       window.location.href = weChatRedirectUrl + '/author';
            //     },2000)
            // } else {
            //   // 不是微信端
            //   // 如果有保存问答url 吊起app方法
            //   if (ua.indexOf("iosapp") != -1 || ua.indexOf("androidapp") != -1) {
            //     try {
            //       this.$utils.openLogin();
            //     } catch (e) {
            //       console.log(e);
            //     }
            //   } else {
            //     this.$router.replace('/login');
            //   }
            // }
            // //结束

            setTimeout(function () {
              window.location.href = weChatRedirectUrl + "/author";
            }, 2000);
            resolve(obj);
          }
          resolve(obj);
        } else {
          reject(requestObj);
        }
      }
    };
  });
};

var ajaxForGetToken = (type = "GET", url = "", data = {}, async = true) => {
  return new Promise((resolve, reject) => {
    // 定义一个promise
    type = type.toUpperCase();
    let requestObj;
    if (window.XMLHttpRequest) {
      requestObj = new XMLHttpRequest();
    } else {
      for (i = 0; i < aVersions.length; i++) {
        try {
          requestObj = new ActiveXObject(aVersions[i]);
          return;
        } catch (Error) { }
      }
    }
    if (type == "GET") {
      let dataStr = ""; // 数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + "=" + data[key] + "&";
      });
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      url = url + "?" + dataStr;
      requestObj.open(type, url, async);
      // requestObj.setRequestHeader("x-channel", "FM_WXH5-2");
      requestObj.setRequestHeader("x-channel", sessionStorage.getItem('isBocAPP') == '1' ? "FM_WXH5-20" : "FM_WXH5-2");
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      var lang = localStorage.getItem("lang");
      if (lang == 't') {
        requestObj.setRequestHeader("locale", "taiwan");
      } else {
        requestObj.setRequestHeader("locale", "cn");
      }
      requestObj.send();
    } else if (type == "POST") {
      requestObj.open(type, url, async);
      // requestObj.setRequestHeader("x-channel", "FM_WXH5-2");
      requestObj.setRequestHeader("x-channel", sessionStorage.getItem('isBocAPP') == '1' ? "FM_WXH5-20" : "FM_WXH5-2");
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      ); //必须,否则无法传参
      requestObj.send(data);
    } else {
      reject("error type");
    }
    requestObj.onreadystatechange = () => {
      if (requestObj.readyState == 4) {
        if (requestObj.status == 200) {
          let obj = requestObj.response;

          debugger
          if (requestObj.getResponseHeader("x-auth-token")) {
            // console.log('返回的请求头有token 自动设置')
            window.localStorage.setItem(
              XAUTHTOKEN,
              requestObj.getResponseHeader("x-auth-token")
            );
          }
          if (typeof obj !== "object") {
            obj = JSON.parse(obj);
          }
          if (obj.header.status == 1105) {
            console.log(obj.header.msg);
            window.localStorage.removeItem(XAUTHTOKEN);
            //  window.sessionStorage.setItem("E_BEFORE_LOGIN_URL_EXHIBITION_NEW", window.location.href);

            // //开始
            // let ua = window.navigator.userAgent.toLowerCase();
            // if (ua.match(/micromessenger/i) == "micromessenger") {
            //     setTimeout(function(){
            //       window.location.href = weChatRedirectUrl + '/author';
            //     },2000)
            // } else {
            //   // 不是微信端
            //   // 如果有保存问答url 吊起app方法
            //   if (ua.indexOf("iosapp") != -1 || ua.indexOf("androidapp") != -1) {
            //     try {
            //       this.$utils.openLogin();
            //     } catch (e) {
            //       console.log(e);
            //     }
            //   } else {
            //     this.$router.replace('/login');
            //   }
            // }
            // //结束

            setTimeout(function () {
              window.location.href = weChatRedirectUrl + "/author";
            }, 2000);

            resolve(obj);
          }
          resolve(obj);
        } else {
          reject(requestObj);
        }
      }
    };
  });
};

var currency_type = localStorage.getItem("currency_type");
export const numberToCoupon = (
  coupon_code,
  currency_type = currency_type,
  commodity_id = "",
  payment_annual = ""
) =>
  ajax(
    "POST",
    baseFMUrl + "/coupon/exchange_code",
    "coupon_code=" +
    coupon_code +
    "&currency_type=" +
    currency_type +
    "&commodity_id=" +
    commodity_id +
    "&payment_annual=" +
    payment_annual,
    true
  );
// 小肥奖品使用
export const clickToUseXiaoFei = user_gift_id =>
  ajax(
    "POST",
    baseFMUrl + "/h5/xiaofei/gift/status/update",
    "user_gift_id=" + user_gift_id,
    true
  );
// 小飞 我的奖品列表
export const getXiaoFeiPresentList = () =>
  ajax("GET", baseFMUrl + "/h5/xiaofei/gift/list", {});
// 获取小肥弹幕列表
export const getXiaoFeiBarrages = () =>
  ajax("GET", baseFMUrl + "/h5/xiaofei/barrages", {});
// 每次进入小肥H5
export const getXiaofeiGameData = () =>
  ajax("POST", baseFMUrl + "/h5/xiaofei", "", true);
// 领取小飞奖品
export const getXiaoFeiPresent = () =>
  ajax("POST", baseFMUrl + "/h5/xiaofei/get_gift", "", true);
// 玩游戏 or分享
export const playOrShareGame = type =>
  ajax("POST", baseFMUrl + "/h5/xiaofei/play_or_share", "type=" + type, true);
// 好友助力
export const helpHimForFlowing = playerid =>
  ajax("POST", baseFMUrl + "/help/prompt", "playerid=" + playerid, true);
// 分享成功后
export const shared = playerid =>
  ajax("POST", baseFMUrl + "/help/shared", "playerid=" + playerid);

export const getHelpShareData = playerid =>
  ajax("GET", baseFMUrl + "/help/aofp", { playerid: playerid });
// 拿微信信息
export const getWXConfig = url =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/wechat/jsapi_ticket",
    "url=" + url,
    true
  );
// 拿微信信息get
export const getWXConfigFromGet = url =>
  ajax("GET", baseFMUrl + "/wechat/jsapi_ticket", { url: url }, true);
// 微信流量分享活动data
export const getHelpActivityData = type =>
  ajax("GET", baseFMUrl + "/help/prmt", { type: type });
// 查询流量
export const getDataFlowingData = () =>
  ajax("GET", baseFMUrl + "/card/remaining", {});
// 获取用户信息
export const getUserData = () => ajax("GET", baseFMUrl + "/user/get_info", {});
// 查询用户是否关注公众号
export const checkUserFollow = user_id =>
  ajax("GET", baseFMUrl + "/wechat/issubscribe", { user_id: user_id });

// 新版使用优惠券
export const useCouponByTwoId = (promotion_id, coupon_id) =>
  ajax(
    "POST",
    baseFMUrl + "/coupon/verification2",
    "promotion_id=" + promotion_id + "&coupon_id=" + coupon_id
  );

// 使用优惠券
export const useCouponByCode = user_coupon_code =>
  ajax(
    "POST",
    baseFMUrl + "/coupon/verification_coupon", // https://testapi.findmacau.com/fm/coupon/promotion/list
    "user_coupon_code=" + user_coupon_code
  );
// 领卷中心列表
export const couponList = (status, page, per_page) =>
  ajax(
    "GET",
    baseFMUrl + "/coupon/list", //https://testapi.findmacau.com/fm/coupon/promotion/list
    { status: status, page: page, per_page: per_page }
  );

// /coupon/user/list/
// 新的我的领券列表
export const newUserCouponList = (status, page, per_page) =>
  ajax(
    "GET",
    baseFMUrl + "/coupon/user/list", //https://testapi.findmacau.com/fm/coupon/promotion/list
    { status: status, page: page, per_page: per_page }
  );
export const newConsumerUserCouponList = (status, page, per_page) =>{
  let params = { status: status, page: page, per_page: per_page };
  if(isEnglishPhone()){
    params.language="en"
  }
  return ajax(
    "GET",
    baseFMUrl + "/coupon/consumer/user/list", //https://testapi.findmacau.com/fm/coupon/promotion/list,
    params
  );
  }
// 用户user_coupon_code 详情查询
export const myCouponItemById = user_coupon_code =>
  ajax("GET", baseFMUrl + "/coupon/detail", {
    user_coupon_code: user_coupon_code
  });

// // 用户user_coupon_code 详情查询
// export const newMyCouponItemById = (user_coupon_code,promotion_id)=>
// ajax('GET' , baseFMUrl + '/coupon/detail_info',
//   {
//     'user_coupon_code': user_coupon_code,
//     'promotion_id':promotion_id
//   });

// 新领券中心详情页面
export const newCouponPromotionItemById = (
  promotion_id,
  user_coupon_code = ""
) =>
  ajax("GET", baseFMUrl + "/coupon/detail_info", {
    promotion_id: promotion_id,
    user_coupon_code: user_coupon_code
  });
// 领券中心详情页面
export const couponPromotionItemById = promotion_id =>
  ajax("GET", baseFMUrl + "/coupon/promotion", { promotion_id: promotion_id });
//领取优惠券 (领券中心)
export const getPromotionCouponID = promotion_id =>
  ajax(
    "POST",
    baseFMUrl + "/coupon/get", //https://testapi.findmacau.com/fm/coupon/promotion/list
    "promotion_id=" + promotion_id /*+
  'promotion_type='+promotion_type*/
  );

//新领取优惠券 (领券中心)
export const getCouponByIdOrType = (promotion_id, promotion_type = "") =>
  ajax(
    "POST",
    baseFMUrl + "/coupon/get_coupon", // https://testapi.findmacau.com/fm/coupon/promotion/list
    "promotion_id=" + promotion_id + "&promotion_type=" + promotion_type
  );

//领卷中心列表
export const couponPromotionList = (page, per_page) =>
  ajax(
    "GET",
    baseFMUrl + "/coupon/promotion/list", //https://testapi.findmacau.com/fm/coupon/promotion/list
    { page: page, per_page: per_page }
  );

//新 领卷中心列表or商品
export const newcouponPromotionList = (
  page,
  per_page,
  commodity_id,
  hotel_id
) =>
  ajax(
    "GET",
    baseFMUrl + "/coupon/center/list", //https://testapi.findmacau.com/fm/coupon/promotion/list
    {
      page: page,
      per_page: per_page,
      commodity_id: commodity_id,
      hotel_id: hotel_id
    }
  );

// 用微信code换取登录token
export const getWeChatTokenByCode = code =>
  ajaxForGetToken("POST", baseFMUrl + "/auth/login/wechat", "code=" + code);


//用微博code换取登录token
export const getWbTokenByCode = code =>
  ajaxForGetToken("POST", baseFMUrl + "/auth/login/weibo", "code=" + code);



//qq code换取登录token
export const getQQTokenByCode = code =>
  ajaxForGetToken("POST", baseFMUrl + "/auth/login/qq", "code=" + code);


//跳转小程序   type = 1（发现澳门小程序）
export const urlschemePushXCX = wx_xcx_type =>
  ajax("GET", baseFMUrl + "/form/wxxcx/urlscheme", { wx_xcx_type: wx_xcx_type });




// 微博code 换取accesstoken
export const getwbaccessoken = (
  client_id,
  client_secret,
  grant_type,
  code,
  redirect_uri
) =>
  ajax(
    "POST",
    baseFMUrl + "/auth/login/third_platform",
    "client_id=" +
    client_id +
    "&client_secret=" +
    client_secret +
    "&grant_type=" +
    grant_type +
    "&code=" +
    code +
    "&redirect_uri=" +
    redirect_uri
  );
// 获取微博用户信息
export const getwbuserinfoByTokenUid = (access_token, uid) =>
  ajax(
    "POST",
    "https://api.weibo.com/2/users/show.json",
    "access_token=" + access_token + "&uid=" + uid
  );

// 第三方登录
export const third_platform = (
  account,
  password,
  nick_name,
  login_way,
  avatar_url,
  app_channel,
  access_token,
  openid,
  wechat_union_id,
  invitation_code
) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/login/third_platform",
    "account=" +
    account +
    "&password=findmacau" +
    "&nick_name=" +
    nick_name +
    "&login_way=" +
    login_way +
    "&avatar_url=" +
    avatar_url +
    "&app_channel=web" +
    "&access_token=" +
    access_token +
    "&openid=" +
    openid +
    "&invitation_code=" +
    invitation_code +
    "&wechat_union_id=" +
    wechat_union_id
  );


// 第三方登录
export const boc_third_platform = (

  login_way,
  boc_uid,
  boc_openid,

) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/login/third_platform",
    "&login_way=" +
    login_way +
    "&boc_uid=" +
    boc_uid +
    "&app_channel=web" +
    "&boc_openid=" +
    boc_openid
  );
//email+验证码注册
export const regUserWithEmailNCode = (
  email,
  phone_password,
  email_code,
  invitation_code
) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/regist/email",
    "email=" +
    email +
    "&phone_password=" +
    phone_password +
    "&invitation_code=" +
    invitation_code +
    "&email_code=" +
    email_code
  );

// 手机+验证码注册
export const regUserWithNumberNCode = (
  phone_number,
  phone_password,
  sms_code,
  invitation_code
) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/regist/phone",
    "phone_number=" +
    phone_number +
    "&phone_password=" +
    phone_password +
    "&invitation_code=" +
    invitation_code +
    "&sms_code=" +
    sms_code
  );
//email验证码 找回密码
// restPasswordWithEmailNCode
export const restPasswordWithEmailNCode = (
  email,
  phone_password,
  email_code,
  invitation_code
) =>
  ajax(
    "POST",
    baseFMUrl + "/auth/rest_password/email_code",
    "email=" +
    email +
    "&phone_password=" +
    phone_password.toUpperCase() +
    "&invitation_code=" +
    invitation_code +
    "&email_code=" +
    email_code
  );

//手机验证码 找回密码
export const restPasswordWithCode = (phone_number, phone_password, sms_code) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/rest_password/sms_code",
    "phone_number=" +
    phone_number +
    "&phone_password=" +
    phone_password.toUpperCase() +
    "&sms_code=" +
    sms_code
  );
//email+密码登录
export const loginWithEmailNPassword = (email, phone_password) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/login/email",
    "email=" + email + "&phone_password=" + phone_password.toUpperCase()
  );

// 手机号码+密码登录
export const loginWithPhoneNPassword = (phone_number, phone_password) =>
  ajaxForGetToken(
    "POST",
    baseFMUrl + "/auth/login/phone",
    "phone_number=" +
    phone_number +
    "&phone_password=" +
    phone_password.toUpperCase()
  );

//手机收取验证码
export const verifyCode = (phone_number, type) =>
  ajax(
    "POST",
    baseFMUrl + "/auth/send_sms_code",
    "phone_number=" + phone_number + "&type=" + type
  );

//邮箱收取验证码
export const verifyCodeToEmail = (email, type) =>
  ajax(
    "POST",
    baseFMUrl + "/auth/send_email_code",
    "email=" + email + "&type=" + type
  );

export const FMListData = (
  shop_category_id,
  page,
  per_page,
  keywords,
  region_id,
  shop_sub_category_id,
  lat,
  lon,
  distance
) =>
  ajax("GET", baseFMUrl + "/find/shop/shopList", {
    shop_category_id: shop_category_id,
    page: page,
    per_page: per_page,
    keywords: keywords,
    region_id: region_id,
    shop_sub_category_id: shop_sub_category_id,
    lat: lat,
    lon: lon,
    distance: distance
  });

export const shopFMData = shopId =>
  ajax("GET", baseFMUrl + "/find/shop/shopDetail", { shopId: shopId });

//抽奖活动
export const prizeUserinfo = () => ajax("POST", baseFMUrl + "/prize/userinfo");

export const prizeUserShare = () => ajax("POST", baseFMUrl + "/prize/share");

export const prizeStart = (prize_draw_activity_id) => ajax("POST", baseFMUrl + "/prize/start", "prize_draw_activity_id=" +
  prize_draw_activity_id);

export const prizeExchange = (awards_type, prize_draw_activity_id) =>
  ajax(
    "POST",
    baseFMUrl + "/prize/exchange",
    "awards_type=" +
    awards_type +
    "&prize_draw_activity_id=" +
    prize_draw_activity_id
  );

export const prizeUserAwardsList = () =>
  ajax("POST", baseFMUrl + "/prize/awards/list");

//点赞
export const doLike = (shop_id, token) => {
  return new Promise((resolve, reject) => {
    let requestObj;
    if (window.XMLHttpRequest) {
      // requestObj = new window.XMLHttpRequest();
      requestObj = new XMLHttpRequest();
    } else {
      // requestObj =new ActiveXObject('Microsoft.XMLHTTP');
      for (i = 0; i < aVersions.length; i++) {
        try {
          requestObj = new ActiveXObject(aVersions[i]);
          return;
        } catch (Error) { }
      }
    }
    let url = baseFMUrl + "/find/user/saveShopLike";
    // console.log(url);
    requestObj.open("POST", url, true);
    requestObj.setRequestHeader("x-auth-token", token);
    var formData = new FormData();
    formData.append("shop_id", shop_id);
    requestObj.send(formData);

    requestObj.onreadystatechange = () => {
      if (requestObj.readyState == 4) {
        if (requestObj.status == 200) {
          let obj = requestObj.response;
          // console.log(obj);

          if (typeof obj !== "object") {
            obj = JSON.parse(obj);
          }
          resolve(obj);
        } else {
          reject(requestObj);
        }
      }
    };
  });
};
//附近惊喜
export const surprise = (lat, lon) => {
  return new Promise((resolve, reject) => {
    let requestObj;
    if (window.XMLHttpRequest) {
      // requestObj = new window.XMLHttpRequest();
      requestObj = new XMLHttpRequest();
    } else {
      // requestObj =new ActiveXObject('Microsoft.XMLHTTP');
      for (i = 0; i < aVersions.length; i++) {
        try {
          requestObj = new ActiveXObject(aVersions[i]);
          return;
        } catch (Error) { }
      }
    }
    let url = baseFMUrl + "/event/locations?lat=" + lat + "&lon=" + lon;
    // console.log(url);
    requestObj.open("GET", url, true);
    requestObj.send();
    requestObj.onreadystatechange = () => {
      if (requestObj.readyState == 4) {
        if (requestObj.status == 200) {
          let obj = requestObj.response;
          // console.log(obj);
          if (typeof obj !== "object") {
            obj = JSON.parse(obj);
          }
          resolve(obj);
        } else {
          reject(requestObj);
        }
      }
    };
  });
};



// WEBPACK FOOTER //
// ./src/service/getData.js